<template>
  <div class="experience">
    <van-nav-bar
      title="呼呼打药"
      left-arrow
    >
      <van-icon
        name="close"
        slot="right"
        class-prefix="close-icon"
      />
    </van-nav-bar>
    <div class="mid">
      <img
        src="./logo.png"
        alt=""
      >
      <h3 class="h3">呼呼打药</h3>
      <p class="p1">体验非农户身份功能<br />请下载呼呼打药APP</p>
    </div>
    <div class="foot">
      <downApp></downApp>
    </div>
  </div>
</template>
<script>
import downApp from '../../components/downApp/downApp';

export default {
  name: 'experience',
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {},
  components: {
    downApp,
  },
};
</script>
<style lang="stylus" scoped>
.experience
  .mid
    padding-top 80px
    img
      display inline-block
      width 70px
      height 70px
      margin 0 auto 10px
    .h3
      font-size 18px
      color #333333
      margin-bottom 22px
    .p1
      font-size 15px
      color #999999
      line-height 23px
</style>
